import modals from '../modal'

export default (function() {
  'use strict';

  let practiceAreaData;
  let practiceAreaModal;
  let practiceAreaModalTriggers;
  let practiceAreaModalNext;
  let banners;
  var close = document.querySelector('.modal__close')
  var openers = document.querySelectorAll('.acuity--practice-area');
  const practiceAreaGrid = document.querySelector('.acuity--practice-areas-three')

  function showPracticeAreaDetail(practiceAreaUri) {

    const practiceAreaDetails = practiceAreaData[practiceAreaUri]

    const nextPrevDetails = Object.keys(practiceAreaData);
    const currentIndex = nextPrevDetails.indexOf(practiceAreaUri)

    const practiceAreaDetailsContainer = practiceAreaModal
    const titleElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-title]')
    const copyElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-copy]')
    const bulletElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-bullets]')
    const numberElem = document.querySelector('.carousel-status');
    let nextElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-uri-next]')

    titleElem.innerHTML = practiceAreaDetails.title
    copyElem.innerHTML = practiceAreaDetails.copy
    bulletElem.innerHTML = practiceAreaDetails.bullets
    numberElem.innerHTML = '0' + (currentIndex + 1)
   // Get the details of the next person
   if(currentIndex === nextPrevDetails.length - 1){
    let nextArea = nextPrevDetails[0];
    nextElem.setAttribute('data-practice-area-uri-next', nextArea);

   } else {
    let nextArea = nextPrevDetails[currentIndex+1];
    nextElem.setAttribute('data-practice-area-uri-next', nextArea);
   }

    document.querySelector('.js-practice').classList.remove('hide');


  }

  function clearPracticeAreaDetail() {
    const practiceAreaDetailsContainer = practiceAreaModal

    const titleElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-title]')
    const copyElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-copy]')
    const bulletElem = practiceAreaDetailsContainer.querySelector('[data-practice-area-bullets]')
    const numberElem = practiceAreaDetailsContainer.querySelector('.carousel-status');

    numberElem.innerHTML = ''
    titleElem.innerHTML = ''
    copyElem.innerHTML = ''
    bulletElem.innerHTML = ''
  }

  function handlePracticeAreaTriggerClick(event) {
    event.preventDefault()
    document.querySelector('body').classList.add('show-menu');
    document.querySelector('.slides--container').classList.remove('hide');
    console.log(event.target)
    showPracticeAreaDetail(event.target.dataset.practiceAreaUri)
    practiceAreaModal.classList.remove('hide')
    banners.forEach((banner) => {
      banner.classList.add('hide-mobile')
    })
  }

  function setupPracticeAreaGrid() {
    practiceAreaData = JSON.parse(document.getElementById('PracticeAreasData').textContent.trim())
    console.log(practiceAreaData)
    practiceAreaModalTriggers = [...practiceAreaGrid.querySelectorAll('.acuity--practice-area')]
    banners = [...document.querySelectorAll('.banner')]

    practiceAreaModal = document.getElementById('modal-practice-area-detail')
    practiceAreaModalNext = practiceAreaModal.querySelector('.js-next')

    practiceAreaModalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handlePracticeAreaTriggerClick)
    })

    practiceAreaModalNext.addEventListener('click', handleNextPracticeAreaClick)

    close.addEventListener('click', handleModalClose)

  }


  function handleModalClose() {
    practiceAreaModal.classList.add('hide');
    clearPracticeAreaDetail()
    banners.forEach((banner) => {
      banner.classList.remove('hide-mobile')
    })
    document.querySelector('body').classList.remove('show-menu');
  }

  function handleNextPracticeAreaClick(event, practiceAreaUri){

    event.preventDefault()

    document.querySelector('.js-practice').classList.add('hide');
    setTimeout(() => {
    showPracticeAreaDetail(event.target.dataset.practiceAreaUriNext)
    }, 100);

  }


  function init() {
    if (!practiceAreaGrid) {
      return;
    }
    window.addEventListener('DOMContentLoaded', () => {
      setupPracticeAreaGrid()
    })
  }

  return {
    init,
  }

})();
